<template>
  <ion-page>
    <!-- <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start" @click="goPrev()">
            <ion-icon :icon="arrowBackOutline" />
          </ion-buttons>
          <ion-title>Search</ion-title>
        </ion-toolbar>
      </ion-header> -->
      <ion-searchbar ref="searchRef" mode="ios" class="search-bar" animated="true" placeholder="Search for a team" @ionInput="searchTeam($event)" autofocus />
    <ion-content class="menu-content" ref="contentRef">
      <ion-item class="pl-10">
        <ion-label>Season</ion-label>
        <ion-select placeholder="Select One" v-model="filterSeason" @ionChange="filterSeasonChange">
          <ion-select-option v-for="season in seasons" :key="season._id" :value="season._id">{{ season._id }}</ion-select-option>
        </ion-select>
      </ion-item>
      <!-- <ion-item class="pl-10">
        <ion-label>Filter By</ion-label>
        <ion-select placeholder="Select One" v-model="filterTeams" @ionChange="filterTeamsChange">
          <ion-select-option v-for="filTeam in filterTeamsList" :key="filTeam.value" :value="filTeam.value">{{ filTeam.name }}</ion-select-option>
        </ion-select>
      </ion-item> -->
      <div class="team-list" :key="key" v-if="filterTeams === ''">
        <div class="team-option" v-for="team in filteredTeams" :key="team._id" @click="menuNavigation(`/teams/${team._id}`)">
          <TeamLogo :team="team" />
          <ion-label>{{ team.name }}</ion-label>
        </div>

        <!-- Add pagination controls -->
        <div class="pagination-controls">
          <ion-button :disabled="currentPage === 1" @click="changePage(currentPage - 1)">
            Previous
          </ion-button>
          <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
          <ion-button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">
            Next
          </ion-button>
        </div>
      </div>
      <div class="competition-list" :key="key" v-if="filterTeams === 'competitions'">
        <div class="accordion-list">
          <div class="accordion" v-for="comp in filteredCompetitions" :key="comp._id">
            <div class="accordion-header" @click="toggleAccordion(comp)">
              <span>
                {{ get(comp, 'name', '') }}
              </span>
              <div>
                <span v-if="get(comp, 'accordionOpen', false)">▲</span>
                <span v-else>▼</span>
              </div>
            </div>
            <transition name="slide">
              <div class="accordion-content" v-if="get(comp, 'accordionOpen', false)">
                <!-- Your content goes here -->
                <!-- <p>Accordion Content</p> -->
                <div class="team-list-competition">
                  <div class="team-option" v-for="team in get(comp, 'teams', [])" :key="team._id" @click="menuNavigation(`/teams/${team._id}`)">
                    <TeamLogo :team="team" />
                    <ion-label>{{ team.name }}</ion-label>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
import { loadingController, menuController } from "@ionic/vue";
import TeamLogo from '../matches/base/team-logo.vue'
import _ from 'lodash';
// import moment from 'moment';
export default {
  components: {
    TeamLogo
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    return {
      get: _.get,
      teams: [],
      key: 1,
      filterSeason: 'All Seasons',
      filterTeams: '',
      filterTeamsList: [
        { name: 'All', value: '' },
        { name: 'Competitions', value: 'competitions' },
      ],
      competitions: [],
      search: '',
      currentPage: 1,
      itemsPerPage: 100,
      totalPages: 1,
      totalCount: 0,
    };
  },
  created() {
    const that = this;
    this.searchTeam = _.debounce(async function(e) {
      const search = e.target.value;
      that.search = search;
      that.currentPage = 1; // Reset to first page on new search
      await that.fetchTeams(search);
      that.key++;
    }, 700);
  },
  async mounted() {
    try {
      this.$store.dispatch('national/setup');
      await this.fetchTeams();
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
    setTimeout(() => this.$refs.searchRef.$el.setFocus(), 500);
  },
  computed: {
    seasons(){
      const seasons =  this.$store.state.national.seasons;
      return seasons.sort((a, b) => b._id - a._id).concat({ _id: 'All Seasons' });
    },
    entity(){
      return this.$store.getters['national/getEntity'];
    },
    filteredTeams() {
      console.log({
        filterSeason: this.filterSeason,
        teams: this.teams
      });
      const { filterSeason, teams } = this;
      if (filterSeason === 'All Seasons') return teams;
      if (filterSeason) return teams.filter(team => team.season === filterSeason);
      return teams;
    },
    filteredCompetitions() {
      const { competitions } = this;
      const mapComp = _.map(competitions, (c) => {
        return {
          _id: c._id,
          teamNames: _.map(c.teams, 'name'),
        }
      });
      // Filter competitions based on the search
      if (this.search) {
        const searchedComps = _.filter(competitions, (comp) => {
          const teamNames = _.map(comp.teams, 'name');
          return _.filter(teamNames, (teamName) => {
            return _.includes(teamName.toLowerCase(), this.search.toLowerCase());
          }).length > 0;
        });
        console.log({
          searchedComps
        });
        return searchedComps;
      }
      console.log({
        mapComp
      });
      return _.orderBy(competitions, ['order'], ['asc']);
    },
    // groupTeamsByCompetition() {
    //   const { filteredTeams } = this;
    //   return _.groupBy(filteredTeams, 'competition');
    // }
  },
  methods: {
    filterSeasonChange() {
      this.getCompetitions();
    },
    filterTeamsChange() {
      this.getCompetitions();
    },
    async getCompetitions() {
      if (this.filterTeams === 'competitions') {
        console.log('Getting comps');
        const params = {};
        loadingController
          .create({ message: "Getting Competitions..." })
          .then(async loading => {
            loading.present();
            if (this.filterSeason !== 'All Seasons') params.season = this.filterSeason;
            const resComps = await this.$http.get("/assemble/api/v1/live/competitions", {
              params
            });
            this.competitions = _.get(resComps, 'data.data', []);
            for (const comp of this.competitions) {
              comp.accordionOpen = false;
            }
            console.log({
              resComps
            });
            loading.dismiss();
          });

      }
    },
    menuNavigation(url){
      menuController.close("side");
      if(this.entity && this.entity.level && this.entity.name){
        url = `/c/${this.entity.level}/${this.entity.name}${url}`
      }
      this.$router.push(url);
    },
    goPrev() {
      this.$router.go(-1);
    },
    toggleAccordion(comp) {
      comp.accordionOpen = !comp.accordionOpen;
    },
    async changePage(page) {
      this.currentPage = page;
      await this.fetchTeams();
      // Get the IonContent element and scroll to top
      const content = this.$refs.contentRef.$el;
      if (content) {
        await content.scrollToTop(300);
      }
    },
    async fetchTeams(search = '') {
      try {
        loadingController
          .create({ message: "Loading Teams..." })
          .then(async loading => {
            loading.present();
            const params = {
              page: this.currentPage,
              limit: this.itemsPerPage,
              search
            };

            if (this.entity && this.entity._id) {
              params.entityType = this.entity.level;
              params.entityId = this.entity._id;
            }

            const resTeam = await this.$http.get("/assemble/api/v1/live/teams", { params });
            this.teams = resTeam.data.data;
            this.totalPages = resTeam.data.pagination.totalPages;
            this.totalCount = resTeam.data.pagination.totalCount;
            loading.dismiss();
          });
      } catch (error) {
        console.error(error);
      }
    },
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  color: #fff;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.team-list {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
  background: transparent;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
   box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: .15rem;
    background-color: rgba(0,0,0,0.3);
  }
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.competition-list {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 2rem;
}

.accordion-list {
  width: 80rem;
  // width: 100%;
  margin: 0 1.5rem;
}

.accordion {
  margin-bottom: 10px;
  min-width: 12rem;
  border-radius: 10px;
  overflow: hidden;
  background-color: #17181B ;
  color: white;
}

.accordion-header {
  cursor: pointer;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  background-color: #222;
}

.accordion-content {
  padding: 15px;
}

.team-list-competition {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.rotate-arrow {
  transform: rotate(180deg);
  transition: transform 0.2s ease-in-out;
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.pagination-controls {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;

  .page-info {
    color: white;
    font-family: 'Cairo';
  }
}

</style>